import { Api } from "../api/api";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs/Observable";

@Injectable()
export class ReportProvider {
  private url: string = "reports";

  constructor(public api: Api) {}

  post(toUserId: number, category: string, reason: string): Observable<any> {
    return this.api.post(this.url, {
      to_user_id: toUserId,
      category: category,
      reason: reason
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/report/report.ts